import {
  Button,
  SequenceMenu,
  SequenceMenuItemType,
  IconEllipsisHorizontal,
  GreyGrey60,
  Center
} from '@sequencehq/core-components'

export const ProductListPriceKebabMenu = ({
  items,
  'data-testid': dataTestId
}: {
  items: SequenceMenuItemType[]
  'data-testid'?: string
}) => {
  return (
    <SequenceMenu
      width={226}
      alignment="bottom-right"
      items={items}
      menuButton={
        <Button variant="ghost" size="24px" data-testid={dataTestId}>
          <Center flexShrink="0">
            <IconEllipsisHorizontal color={GreyGrey60} />
          </Center>
        </Button>
      }
    />
  )
}
